import { observable, toJS } from "mobx";
import _ from 'lodash';
import lscache from "lscache";
import moment from "moment";

export default class CRUDAnaliseCriticaStore {

    @observable salvando;
    @observable dadosArmazenamento;
    @observable analise;
    @observable razaoSocial

    @observable carregar;
    @observable carregandoNCM;
    @observable carregandoRadical;

    @observable envioConcluido;
    @observable salvarConcluido;

    @observable erroNCM;
    @observable erroRadical;
    @observable erroCNPJ;
    @observable erroUN;
    @observable erroAnexo;
    @observable erroCarregamento;
    @observable falhaValidacao;
    @observable alertaEmail;
    @observable mensagemErro;
    @observable mensagemNcmBloqueado;
    @observable mensagemSucesso;
    @observable mensagemCrossdoking;

    @observable grupoCnpjs;
    @observable grupoCnpjsSelecionados;
    @observable tiposMercadoria;
    @observable atualizarSelParceiro;
    @observable modalConfig;

    @observable listaAnexos;

    @observable campoUn;
    @observable mensagemProdQuim;

    constructor(service) {
        this.salvando = false;
        this.carregar = false;
        this.service = service;
        this.carregandoNCM = false;
        this.carregandoRadical = false;

        this.erroNCM = "";
        this.alertaEmail = "";
        this.erroRadical = false;
        this.erroCNPJ = "";
        this.erroAnexo = false;
        this.erroCarregamento = false;
        this.erroUN = false;
        this.falhaValidacao = false;

        this.atualizarSelParceiro = false;
        this.envioConcluido = false;
        this.salvarConcluido = false;

        this.download = document.createElement('a')
        document.body.appendChild(this.download)
        this.download.style = "display: none"
        this.download.target = "_blank"

        this.dadosArmazenamento = [
            { "label": "Área coberta", "valor": "FlgAreaCob" },
            { "label": "Restrição a impacto", "valor": "FlgImpact" },
            { "label": "Restrição a umidade", "valor": "FlgUmidad" },
            { "label": "Anuência ANVISA", "valor": "FlgArmzAnvisa" },
            { "label": "Restrição a poeira", "valor": "FlgPoeir" },
            { "label": "Restrição a luz", "valor": "FlgLuz" }];

        this.analise = {
            Id: 0,
            EstabId: null,
            ParcId: null,
            CdImo: null,
            Email: "",
            MembershipuseridIncl: lscache.get('MembershipuserId'),
            FlgAreaCob: 0,
            FlgArmzAnvisa: 0,
            FlgImpact: 0,
            FlgLuz: 0,
            FlgPoeir: 0,
            FlgUmidad: 0,
            FlgProdQuim: 0,
            IndTipoMerc: "",
            IndStatus: "D",
            DscObs: "",
            DscRegCarreg : "Normal",
            DtIncl: null,
            DtUltimoEnvio: null,
            FlgPalet : 0,
            CdEmbal: "", //TODO: verificar aonde preenche
            ValAlt: 0, //TODO: verificar aonde preenche
            ValLarg: 0, //TODO: verificar aonde preenche
            ValComp: 0, //TODO: verificar aonde preenche
            ValPeso: 0, //TODO: verificar aonde preenche
            IndRegEmpPalet: 0, //TODO: verificar aonde preenche
            DscObsFluxo: ""
        };

        this.grupoCnpjs = [];
        this.grupoCnpjsSelecionados = [];
        this.tiposMercadoria = [];

        this.mensagemErro = false;
        this.mensagemSucesso = false;
        this.mensagemErroPadrao = "Ocorreu um erro. Não foi possível completar essa ação no momento.";
        this.mensagemSucessoPadraoSalvar = "Análise crítica salva com sucesso.";
        this.mensagemSucessoPadraoAprovar = "Análise crítica enviada para aprovação.";
        this.mensagemNcmBloqueado = "Não é possível desovar cargas deste NCM.";
        this.mensagemCrossdoking = false;
        this.campoUn = false
        this.mensagemProdQuim = false

        this.listaAnexos = [];
        this.listaAnexosApagados = []

        this.razaoSocial = null // Separei o campo Razao Social dos demais para não dar problema atualizando o objeto this.analise, além de facilitar sua modificação

        this.modalConfig = {
            labelEnviar: "ENVIAR PARA APROVAÇÃO",
            labelConfirmar: "SALVAR",
            onClickSalvar: () => this.salvarAnalise(),
            onClickEnviar: () => this.enviarParaAprovacao()
        };

    };

    setDataEnvio = () => {
        if (!_.get(this.analise, 'DtIncl')) {
            _.set(this.analise, 'DtIncl', moment().format());
        }
        _.set(this.analise, 'DtUltimoEnvio', moment().format());
    };

    carregarAnalise = (id) => {
        this.analise = {};
        this.listaAnexos = [];
        this.erroCarregamento = false;
        this.carregar = true;

        this.service.obterAnalise(id).then(response => {
            if (response && response.data) {
                if (response.data.Sucesso) {
                    this.analise = response.data.Analise;
                    this.listaAnexos = response.data.Anexos;
                    this.grupoCnpjs = response.data.AnaliseCriticaParceiros;
                    this.razaoSocial = response.data.AnaliseCriticaParceiros.length > 0 && response.data.AnaliseCriticaParceiros[0].Razao
                    this.grupoCnpjs.map((valor, index) => { this.selecionarParceiro(index); });
                    _.set(this.analise, 'Parceiros', this.grupoCnpjs);
                    this.mostrarCampoUn(response.data.Analise.IndTipoMerc === 'QC' ? true : false)
                    this.tiposMercadoria.map(tipo => {
                        if(tipo.value === response.data.Analise.IndTipoMerc){
                            tipo.checked = true
                        }else{
                            tipo.checked = false
                        }
                    })
                    Promise.resolve(this.analise);
                } else {
                    Promise.reject(response.data.MensagemErro);
                }
            } else {
                return Promise.reject();
            }
        })
            .catch((erro) => {
                this.mensagemErro = erro ? erro : this.mensagemErroPadrao;
                this.erroCarregamento = true;
            })
            .finally(() => {
                this.carregar = false;
            });
    };

    salvarAnalise = () => {
        this.salvando = true;
        this.mensagemErro = ""

        //this.setDataEnvio();

        let analiseFormat = {
            QtdAnexos: this.listaAnexos.length,
            Analise: this.analise,
            Parceiros: this.getParceirosSelecionados()
        };

        this.validarCampos();
        if (this.falhaValidacao) return;

        this.service.persistirAnalise(analiseFormat).then(response => {
            if (response && response.data) {
                if (response.data.Sucesso) {
                    const velhaId = this.analise.Id
                    this.analise = response.data.Analise;
                    Promise.all([this.salvarAnexos(response.data.Analise.Id), this.deletarAnexosBanco()]).then(() => {
                        this.salvarConcluido = true
                        //Esse passo é necessário após criar uma nova análise critica para entrar no modo de edição
                        this.configurarModalFinalizar()
                        Promise.resolve(this.analise);
                    }
                    ).catch(err => {
                        this.mensagemErro = erro ? erro : this.mensagemErroPadrao;
                    })
                } else {
                    return Promise.reject(response.data.MensagemErro);
                }
            } else {
                return Promise.reject();
            }
        })
            .catch((erro) => {
                this.mensagemErro = erro ? erro : this.mensagemErroPadrao;
                this.salvarConcluido = false
            })
            .finally(() => { this.salvando = false; });
    };

    enviarAnalise = (id) => {
        this.carregar = true;
        this.envioConcluido = false;
        this.mensagemErro = ""

        if (this.listaAnexosApagados.length > 0) this.deletarAnexosBanco()

        this.service.enviarAnalise(id).then(response => {
            if (response && response.data) {
                if (response.data.Sucesso) {
                    this.analise = response.data.Analise;
                    this.envioConcluido = true;
                    this.configurarModalFinalizar()
                    Promise.resolve(this.analise);
                } else {
                    return Promise.reject(response.data.MensagemErro);
                }
            } else {
                return Promise.reject();
            }
        })
            .catch((erro) => {
                this.mensagemErro = erro ? erro : this.mensagemErroPadrao;
            })
            .finally(() => {
                this.carregar = false;
                this.salvando = false;
            }
            );
    };

    validarCampos = () => {
        this.falhaValidacao = false;
        if (this.erroUN || this.erroRadical || this.erroCNPJ || this.erroNCM || this.alertaEmail || this.erroUN) {
            this.salvando = false;
            this.falhaValidacao = true;
        }

        if (this.listaAnexos.length === 0) {
            this.mensagemErro = "É obrigatória a inclusão de Anexos à Análise Crítica.";
            this.salvando = false;
            this.falhaValidacao = true;
        }
    };


    enviarParaAprovacao = () => {
        this.salvando = true;
        this.mensagemErro = "";
        this.envioConcluido = false;

        //this.setDataEnvio();

        let analiseFormat = {
            QtdAnexos: this.listaAnexos.length,
            Analise: this.analise,
            Parceiros: this.getParceirosSelecionados()
        };

        this.validarCampos();
        if(this.falhaValidacao) return;
        this.service.persistirAnalise(analiseFormat).then( response => {
            if(response && response.data){
                if(response.data.Sucesso){
                    this.analise = response.data.Analise;
                    Promise.all([this.salvarAnexos(response.data.Analise.Id),this.deletarAnexosBanco(), this.configurarModalFinalizar()]).then(() => {
                        return true;
                    }).then(() => {
                        //this.salvarConcluido = true
                        this.enviarAnalise(_.get(this.analise, 'Id'));
                    }).catch(err => {
                        this.mensagemErro = erro ? erro : this.mensagemErroPadrao;
                    })
                } else {
                    return Promise.reject(response.data.MensagemErro);
                }
            } else {
                return Promise.reject();
            }
        }).catch((erro) => {
            this.mensagemErro = erro ? erro : this.mensagemErroPadrao;
            this.salvarConcluido = false
        }).finally(() => { this.salvando = false; });

    };

    setCampoAnalise = (campo, valor) => {
        if (typeof campo === 'string') campo = [campo];

        campo.map(item => {
            let val = valor;
            if (val) {
                val = valor.hasOwnProperty('target') ? valor.target.value : valor;
                if(item === 'radical')
                    val = val ? val.replace(/([\u0300-\u036f]|[^0-9a-zA-Z])/g, '') : val;
            }
            _.set(this.analise, item, val);
        });
    };

    carregarNCM = () => {
        this.carregandoNCM = true;
        this.erroNCM = "";
        this.mensagemCrossdoking = false;

        if (_.get(this.analise, "Ncm") && _.get(this.analise, "Ncm").length >= 8) {
            this.service.carregarPorNcm(_.get(this.analise, "Ncm")).then(response => {
                if (response && response.data) {
                    this.setCampoAnalise('DscMerc', response.data.ShortName);
                    if (response.data.Restrito) { this.mensagemCrossdoking = true; }
                    if (response.data.Bloqueado) { this.erroNCM = this.mensagemNcmBloqueado }
                } else {
                    return Promise.reject();
                }
            })
                .catch(() => {
                    this.setCampoAnalise('DscMerc', "");
                    this.erroNCM = "NCM não encontrado";
                })
                .finally(() => {
                    this.carregandoNCM = false;
                });

        } else {
            this.erroNCM = "Preencha o campo NCM (8 dígitos)";
            this.carregandoNCM = false;
            this.setCampoAnalise('DscMerc', "")
        }

    };

    listarTiposMercadoria = () => {
        this.service.listarTiposMercadoria().then(response => {
            if(response && response.data){
                response.data.map(tipo => {
                    this.tiposMercadoria.push({id: tipo.Codigo, value: tipo.Codigo, label: tipo.Descr})
                })
            }
        })
    }

    listarParceiroPorRadical = () => {
        this.carregandoRadical = true;

        if (_.get(this.analise, 'radical')) {
            this.erroRadical = false;

            if(typeof _.get(this.analise, 'radical') === 'string' && (_.get(this.analise, 'radical').length !== 8 && _.get(this.analise, 'radical').length !== 11)) {
                this.carregandoRadical = false;
                this.razaoSocial = null;
                this.erroRadical = "Por favor, insira um CPF ou radical de CNPJ valido";
                return;
            }

            this.limparGrupos();

            this.service.listarParceirosPorRadicalOuCgc(_.get(this.analise, 'radical')).then(response => {
                if (response && response.data && response.data.Parceiros && response.data.Parceiros.length > 0) {
                    this.grupoCnpjs = response.data.Parceiros;
                    this.razaoSocial = response.data.Parceiros[0].Razao // O radical apresenta a mesma razão social para todos os CNPJs atribuidos
                } else if(response && response.data && response.data.MensagemAlerta) {
                    this.razaoSocial = null;
                    this.erroRadical = response.data.MensagemAlerta;
                    this.limparGrupos();
                } else {
                    return Promise.reject();
                }
            })
                .catch(() => {
                    this.limparGrupos();
                    this.erroRadical = true;
                })
                .finally(() => {
                    this.carregandoRadical = false;
                });
        } else {
            setTimeout(() => this.carregandoRadical = false, 1);
            // this.carregandoRadical = false;
            this.limparGrupos();
            this.razaoSocial = null;
        }
    };

    limparGrupos = () => {
        this.grupoCnpjs = [];
        this.grupoCnpjsSelecionados = [];
    };

    anexarArquivo = (arquivo) => {
        if (this.mensagemErro !== "") this.mensagemErro = ""
        Array.from(arquivo.target.files).map((arqv, index) => {
            let filename = arqv.name.replace(/[^a-zA-Z0-9\.]/g, "");
            filename = filename.split('.')[0];
            this.listaAnexos.push({ file: arqv, DscAnex: filename, DscExtenAnex: arqv.name.split('.').pop() })
        })
    };

    salvarAnexos = (id) => {
        this.listaAnexos.map(arquivo => {
            let arqv = new FormData()
            arqv.append('file', arquivo.file);
            this.service.salvarAnexo(arqv, arquivo.DscExtenAnex, arquivo.DscAnex, id).then(response => {
                if (response && response.data) {
                    if (response.data.Sucesso) {
                        arquivo.Id = response.data.AnaliseCritAnexId
                    } else {
                        Promise.reject(response.data.MensagemErro);
                    }
                }
            }).catch(error => {
                this.erroAnexo = error ? error : this.mensagemErroPadrao
            })
        })
    }

    removerAnexo = (id, index) => {
        //Quando eu crio uma nova análise eu só preciso excluir da lista, pois eu ainda não tenho ele salvo no servidor
        if (id === undefined) {
            this.listaAnexos.splice(index, 1);
        } else {
            //Por enquanto vou manter esta parte do código para caso seja necessário mudar a regra de remoção dos anexos
            /* this.service.deletarAnexo(id).then(response => {
                if(response.data){
                    this.listaAnexos.splice(index , 1);
                    this.mensagemSucesso = "Documento apagado com sucesso"
                    //Talvez melhorar a apresentação desta informação
                }else{
                    this.mensagemErro = "Erro ao apagar. Tente novamente."
                }
            }).catch(err => console.log(err)) */
            this.listaAnexos.splice(index, 1);
            this.listaAnexosApagados.push(id)
        }
    };

    deletarAnexosBanco = () => {
        this.listaAnexosApagados.map(id => {
            this.service.deletarAnexo(id).then(() => {
            }).catch(err => this.mensagemErro = err)
        })

        this.listaAnexosApagados = []
    }

    baixarAnexo = (id, index) => {
        if (id === undefined) {
            this.gerarLinkDownload(this.listaAnexos[index].file, this.listaAnexos[index])
        } else {
            const anexo = this.listaAnexos.find(anexo => anexo.Id === id)
            this.service.downloadAnexo(id).then(response => {
                if (response.data) {
                    this.gerarLinkDownload(response.data, anexo)
                }
            }).catch(err => this.mensagemErro = err)
        }
    }

    //Função feita para evitar a repetição de código na parcela acima
    gerarLinkDownload = (dadosArquivo, anexo) => {
        const file = new File([dadosArquivo], `${anexo.DscAnex}.${anexo.DscExtenAnex}`, { type: "octet/stream" })
        const url = window.URL.createObjectURL(file)
        this.download.href = url
        this.download.download = `${anexo.DscAnex}.${anexo.DscExtenAnex}`
        this.download.click()
        window.URL.revokeObjectURL(url)
    }

    getParceirosSelecionados = () => {
        return this.grupoCnpjs.filter(item => item.selecionado);
    };

    selecionarParceiro = (index) => {
        console.log("SELECIONAR PARCEIRO");

        this.atualizarSelParceiro = true;
        _.set(this.grupoCnpjs[index], "selecionado", !_.get(this.grupoCnpjs[index], "selecionado"));
        this.atualizarSelParceiro = false;
    };

    marcarCnpjs = (valor) => {
        this.atualizarSelParceiro = true;
        let marcado = valor.target.checked;
        this.grupoCnpjs.map(item => {
            if (marcado) {
                _.set(item, "selecionado", true);
            } else {
                _.set(item, "selecionado", false);
            }
        });
        this.atualizarSelParceiro = false;
    };

    configurarModalEditar = (id) => {
        this.modalConfig = {
            tipoModal: "Editar",
            modalTitulo: `Editar Análise #${id}`,
            labelEnviar: "ENVIAR PARA APROVAÇÃO",
            labelConfirmar: "SALVAR",
            labelCancelar: "CANCELAR",
            onClickSalvar: () => this.salvarAnalise(),
            onClickEnviar: () => this.enviarParaAprovacao(id)
        };
    };

    configurarModalEnviar = (id) => {
        this.modalConfig = {
            tipoModal: "Configurar",
            modalTitulo: `Enviar Análise #${id}`,
            //labelConfirmar : "ENVIAR NOVAMENTE",
            labelCancelar: "FECHAR",
            onClickSalvar: () => this.enviarAnalise(id)
        };
    };

    configurarModalCadastrar = () => {
        this.modalConfig = {
            tipoModal: "Cadastrar",
            modalTitulo: "Nova Análise",
            labelEnviar: "ENVIAR PARA APROVAÇÃO",
            labelConfirmar: "SALVAR",
            labelCancelar: "CANCELAR",
            onClickSalvar: () => this.salvarAnalise(),
            onClickEnviar: () => this.enviarParaAprovacao()
        };
    };

    configurarModalFinalizar = () => {
        this.modalConfig = {
            tipoModal: "Finalizar",
            modalTitulo: this.envioConcluido ? "Enviado com sucesso!" : "Inserido com sucesso!",
            //labelEnviar : "ENVIAR PARA APROVAÇÃO",
            labelConfirmar: "",
            labelCancelar: "FECHAR"
        };
    };

    mostrarCampoUn = (value) => {
        this.campoUn = value
        if (this.campoUn === false) {
            this.analise.CdImo = null
        }
    }

    mostrarAvisoProdQuim = (value) => {
        if(value === "NC" || value === "QC"){
            this.mensagemProdQuim = true
        }else{
            this.mensagemProdQuim = false
        }
    }

    setRadioChecked = (val) => {
        this.tiposMercadoria.map(tipo => {
            if(tipo.value === val){
                tipo.checked = true
            }else{
                tipo.checked = false
            }
        })
    }

}

/** TODO: remover ao finalizar desenvolvimento
 Analise: {
Id : 0
EstabId : null
DscMerc : “TESTE”
DscObs : “Teste”
CdImo
DscRegCarreg
FlgUmidad
FlgPoeir
FlgAreaCob
FlgArmzAnvisa
FlgPalet
CdEmbal
Ncm
DtIncl
ValAlt
ValLarg
ValComp
ValPeso
ParcId: null
MembershipuseridIncl
FlgProdQuim
IndRegEmpPalet
FlgImpact
FlgLuz
IndStatus
Email
DtUltimoEnvio
DscObsFluxo
}
 * */


// WEBPACK FOOTER //
// ./src/modules/analise/stores/CRUDAnaliseCriticaStore.js